module.exports = "<!-- Generated by IcoMoon.io -->\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n<path d=\"M11 13h-8v-8h4.5l2-2h-8.5v12h12v-8.5l-2 2v4.5z\"></path>\n<path d=\"M16 0h-6.5l2.5 2.5-7.5 7.5 1.5 1.5 7.5-7.5 2.5 2.5v-6.5z\"></path>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./app/assets/svg/new-tab.svg
// module id = 746
// module chunks = 0